import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { SvgIcon } from "@progress/kendo-react-common";
import { checkIcon, clockIcon, dollarIcon } from "@progress/kendo-svg-icons";
import { VehicleSuggestion } from "../Suggestions";
import { formatNumber } from '@progress/kendo-intl';
import { dateFormatter } from 'utils/utils';

const VehicleNumberCell = (props: GridCustomCellProps) => {
  if (!props.field)
    return null;

  const dataItem: VehicleSuggestion = props.dataItem;

  return (
    <td {...props.tdProps} role="button">
      <span style={{ color: dataItem.StatusColor, pointerEvents: 'none' }}>{dataItem.VehicleNumber}</span> ({dataItem.ComplianceDays})
      {dataItem.HasAcceptedOffer && <SvgIcon icon={checkIcon} color="green" />}
      {dataItem.AlternativeAllInRate && <span title={`Alt Rate: ${formatNumber(dataItem.AlternativeAllInRate, 'c2')}`}><SvgIcon icon={dollarIcon} color="#FFC107" /></span>}
      {dataItem.AlternativePickup && <span title={`Alt Pickup: ${dateFormatter(dataItem.AlternativePickup)}`}><SvgIcon icon={clockIcon} color="#0DCAf0" /></span>}
      {dataItem.AlternativeDelivery && <span style={{ paddingLeft: dataItem.AlternativePickup ? 4 : 0 }} title={`Alt Delivery: ${dateFormatter(dataItem.AlternativeDelivery)}`}><SvgIcon icon={clockIcon} color="#FFC107" /></span>}
    </td>
  );
};

export default VehicleNumberCell;